import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Import tailwind
import '@/assets/scss/_index.scss'

import apollo from './apolloClient'

import VueApollo from 'vue-apollo'

import vSelect from 'vue-select'

const apolloProvider = new VueApollo({
  defaultClient: apollo,
})

Vue.use(VueApollo);

Vue.config.productionTip = false

Vue.component('v-select', vSelect)

new Vue({
  router,
  apolloProvider,
  store,
  render: h => h(App)
}).$mount('#app')
